import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {InwardInitValues, InwardModel} from '../models/InwardModel'

interface InwardState {
  loading: boolean
  inward: InwardModel
  inwards: [InwardModel?]
  pagination: {total: number; pages: number}
}

const initialState: InwardState = {
  loading: false,
  inward: InwardInitValues,
  inwards: [],
  pagination: {total: 0, pages: 0},
}

export const InwardSlice = createSlice({
  name: 'inward',
  initialState,
  reducers: {
    startLoading: (state: {loading: boolean}) => {
      state.loading = true
    },
    stopLoading: (state: {loading: boolean}) => {
      state.loading = false
    },
    setInwards: (state, action: PayloadAction<any>) => {
      state.inwards = action.payload.inwards
    },
    setInward: (state, action: PayloadAction<any>) => {
      state.inward = action.payload.inward
    },
    setPagination: (state: {pagination: any}, action: PayloadAction<any>) => {
      state.pagination = action.payload.pagination
    },
  },
})
